module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<td class=\"api-key-input\"> <input type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.api_key ))
    ; __append("\" ")
    ; __append(escapeFn( locals.mode == 'production' ? 'readonly' : '' ))
    ; __append("> </td> ")
    ;  if(locals.mode == 'production') { 
    ; __append(" <td class=\"api-key-show-button text-center\"> <button class=\"show-key-btn text-hide\" type=\"button\" title=\"hide/show key\"> <span class=\"glyphicon ")
    ; __append(escapeFn( locals.show_production ? 'glyphicon-eye-close' : 'glyphicon-eye-open' ))
    ; __append("\"></span> ")
    ; __append(escapeFn( locals.show_production ? 'Hide' : 'Show' ))
    ; __append(" Key </button> </td> ")
    ;  } 
    ; __append(" <td class=\"api-key-copy-button text-right\"> <button class=\"copy-key-btn\" type=\"button\" data-clipboard-text=\"")
    ; __append(escapeFn( locals.clipboard_text ))
    ; __append("\"> <span class=\"glyphicon glyphicon-copy\"></span> </button> </td> <td class=\"created-at text-center\"> ")
    ; __append(escapeFn( locals.key_created_at ))
    ; __append(" </td> <td class=\"status text-center\"> <label class=\"switch\"> <input class=\"active-status-checkbox\" type=\"checkbox\" ")
    ; __append(escapeFn( locals.active ? 'checked' : '' ))
    ; __append("> <div class=\"slider round\"></div> </label> </td> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/api_keys_list_item.ejs
// module id = 823
// module chunks = 1